import React from 'react';
import { STATUS_OPTIONS, STATUS_COLORS } from './constants';

export const StatusBadge = ({ value }) => (
  <span
    data-testid={`status-badge-${value}`}
    className={`inline-block text-[10px] tracking-[0.2em] uppercase font-semibold px-2.5 py-1 border ${STATUS_COLORS[value] || STATUS_COLORS.new}`}
  >
    {value}
  </span>
);

export const StatusSelect = ({ value, onChange, testId }) => (
  <select
    data-testid={testId}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="text-[12px] border border-black/15 px-2 py-1 bg-white focus:outline-none focus:border-[#c9a961]"
  >
    {STATUS_OPTIONS.map((s) => (
      <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
    ))}
  </select>
);

export const StatCard = ({ Icon, label, value, sub }) => (
  <div className="bg-white border border-black/5 p-6 flex items-center gap-5" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="w-12 h-12 rounded-full border border-[#c9a961] flex items-center justify-center">
      <Icon size={20} className="text-[#c9a961]" strokeWidth={1.4} />
    </div>
    <div>
      <p className="text-[10px] tracking-[0.28em] text-[#6b6b6b] font-semibold">{label}</p>
      <p className="font-serif text-3xl text-[#1c1e20] mt-1" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
        {value}
      </p>
      {sub && <p className="text-[12px] text-[#6b6b6b] mt-0.5">{sub}</p>}
    </div>
  </div>
);
